'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Navigation = require('../components/Navigation');

var _Navigation2 = _interopRequireDefault(_Navigation);

var _UIApplication = require('UIComponents/app/UIApplication');

var _UIApplication2 = _interopRequireDefault(_UIApplication);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NavApp = function (_Component) {
  _inherits(NavApp, _Component);

  function NavApp() {
    _classCallCheck(this, NavApp);

    return _possibleConstructorReturn(this, (NavApp.__proto__ || Object.getPrototypeOf(NavApp)).apply(this, arguments));
  }

  _createClass(NavApp, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.title) {
        document.title = this.props.title;
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.title) {
        document.title = this.props.title;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _UIApplication2.default,
        { name: 'growthhub-ui' },
        _react2.default.createElement(_Navigation2.default, null),
        this.props.children
      );
    }
  }]);

  return NavApp;
}(_react.Component);

exports.default = NavApp;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/pages/NavApp.js
// module id = 80
// module chunks = 171